/**
 * Copyright (c) 2023 TechDivision GmbH
 * All rights reserved
 *
 * This product includes proprietary software developed at TechDivision GmbH, Germany
 * For more information see https://www.techdivision.com/
 *
 * To obtain a valid license for using this software please contact us at
 * license@techdivision.com
 *
 * @author Simon Paidla <s.paidla@techdivision.com>
 */

import dayjs from 'dayjs';
import { checkoutFormModel } from './FormModel';

const {
  formField: {
    studioId,
    gender,
    contract,
    firstName,
    lastName,
    street,
    houseNumber,
    postCode,
    city,
    email,
    phonePrefix,
    phone,
    dateOfBirth,
    iban,
    generalTerms,
    marketingTerms,
  },
} = checkoutFormModel;

export default {
  [studioId.name]: '',
  [gender.name]: '',
  [contract.name]: '',
  [firstName.name]: '',
  [lastName.name]: '',
  [street.name]: '',
  [houseNumber.name]: '',
  [postCode.name]: '',
  [city.name]: '',
  [email.name]: '',
  [phonePrefix.name]: '+49',
  [phone.name]: '',
  [dateOfBirth.name]: dayjs().subtract(18, 'year'),
  [iban.name]: '',
  [generalTerms.name]: false,
  [marketingTerms.name]: false,
  paymentChoice: 'DIRECT_DEBIT',
  countryCode: 'DE',
};
